import { CognitoUserPool } from 'amazon-cognito-identity-js';

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
const clientId = process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '';

export const userPool: CognitoUserPool | null =
  userPoolId && clientId
    ? new CognitoUserPool({ UserPoolId: userPoolId, ClientId: clientId })
    : null;

export const COGNITO_HOSTED_DOMAIN = process.env.REACT_APP_COGNITO_HOSTED_DOMAIN || '';
export const SKIP_LOGIN = process.env.REACT_APP_SKIP_LOGIN === 'true';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
